
<template>
  <div class="nav">
    <!--命名路由-->
    <ul>
      <!--this inspection reports XML/HTML tags with missing mandatory attrbutes ,you can specify attrbute name that should not  be reported-->
      <!--home被点击后，一直处于激活状态，因此需要使用精确匹配模式，在router-link中添加exact属性-->
      <router-link :to="{name:'home'}" tag="li" active-class="activeNav" exact>
        <i class="home-tip"></i>
        <span>{{$t('btmNavBar.device')}}</span>
      </router-link>
      <router-link :to="{name:'finder'}" active-class="activeNav" tag="li">
        <i class="finder-tip"></i>
        <span>{{$t('btmNavBar.finder')}}</span>
      </router-link>
      <router-link :to="{name:'account',params:{user:'xu'}}" active-class="activeNav" tag="li" v-if='loginsuccess'>
        <i class="account-tip"></i>
        <span>{{$t('btmNavBar.my')}}</span>
      </router-link>
      <router-link :to="{name:'login'}" active-class="activeNav" tag="li" v-if='loginshowflag'>
        <i class="account-tip"></i>
        <span>{{$t('btmNavBar.my')}}</span>
      </router-link>
    </ul>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
    name: "footernav",
    props: ["loginsuccess", "loginshowflag"],
    data() {
        return {};
    }
};
</script>
<style scoped>
.nav {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
        "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    position: fixed;
    bottom: 0;
    width: 100%;
    font-size: 14px;
    color: #000;
    box-sizing: border-box;
    /* height: 60px; */
    border-top: 1px solid #eee;
    max-width: 576px;
}
.nav ul {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    background-color: #fff
}
.nav ul li {
    flex: 8;
    /* height: 60px; */
    font-size: 0.8rem;font-weight:bold;
    text-align: center;
    padding: 0.3rem 0;
    /* display: flex;
    align-items: center;
    justify-content: center; */
}
.nav ul li i {
    display: block;
    width: 20px;
    height: 20px;
    background-size: 20px;
    margin: 0 auto;
}
.nav ul li span{
    display: block;
    font-size: 0.8rem;
}
/* .nav ul {
    max-width: 720px;
    margin: 0 auto;
    background-color: #fff;
    height: 40px;
} */
/* .nav ul::after {
    content: "";
    display: block;
    clear: both;
} */
/* .nav li {
    width: 33.3%;
    padding: 5px 0;
    float: left;
    text-align: center;
    height: 40px;
    line-height: 40px;
} */

.finder-tip {
    background-image: url(../image/find2.png);
    background-size: 100% 100%;
}
.activeNav .finder-tip {
    background-image: url(../image/find21.png);
}
.home-tip {
    background-image: url(../image/device2.png);
}
.activeNav .home-tip {
    background-image: url(../image/device21.png);
}
.account-tip {
    background-image: url(../image/my2.png);
}
.activeNav .account-tip {
    background-image: url(../image/my21.png);
}
.activeNav {
    color: #fff;
    background-color: #71b8ff;
}
</style>




// WEBPACK FOOTER //
// src/components/footernav.vue